import { Component, OnInit } from '@angular/core';
import { MessageService, Message } from 'primeng/api';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { ScheduleService } from 'src/app/services/schedule.service';


@Component({
  templateUrl: './agenda-summary.component.html'
})
export class AgendaSummaryComponent implements OnInit {
  mySortBy: string;  // Sort By Type
  sortByList = [];
  schedDateList: any[];
  hearingDate =  '';


  displayState: any = {
    workingDiv: false,
    summaryDiv: false,
  };

  constructor(private utilService: UtilitiesService, private messageService: MessageService,
              private  schedService: ScheduleService) { }

  ngOnInit() {
    // this.sortByListOLD = ['Case Number', 'Applicant', 'Status', 'SubStatus', 'Date Received', 'Expiration Date'];
    this.mySortBy = '';
    this.sortByList = [
      { val: 'CaseNum', desc: 'Case Number'},
      { val: 'DateReceived', desc: 'Date Received'},
      { val: 'ApplicantName', desc: 'Applicant' },
      { val: 'AgencyName', desc: 'Agent'},
      { val: 'Status', desc: 'Status'},
      { val: 'SubStatus', desc: 'Sub Status'},
      { val: 'DateConfirmationReceived', desc: 'Date Confirm Rcvd'}
    ];
    this.getHearingDates();
  }

  runAgendaSummary() {
    this.utilService.doAudit(this.mySortBy, 'mySort:');
    this.utilService.doAudit(this.hearingDate, 'hearingDate:');
    const sortBy = this.mySortBy;
    const hearingId = +this.hearingDate;
    if (sortBy.length < 1) {
      this.showToast({key: 'toast', severity: 'info', detail: 'Please select a Sort By Type', summary: 'Info' });
      return;
    } else if (hearingId < 1)
    {
      this.showToast({key: 'toast', severity: 'info', detail: 'Please select a Hearing Date', summary: 'Info' });
      return;
    }
    this.utilService.doAudit('calling agenda summary function...');
    this.schedService.generateAgendaSummaryPdf(hearingId, sortBy).subscribe(data => {
      this.utilService.doAudit('got response from generateAgendaSummaryPdf:');
      if (data) {
        const myUrl = URL.createObjectURL(data);
        window.open(myUrl, '_blank');
        URL.revokeObjectURL(myUrl);
      }
    })
  }

  getHearingDates() {
    const tempDate = new Date();
    const tdy = new Date(tempDate.getFullYear(), tempDate.getMonth(), tempDate.getDate()); // returns today with no time
    const baseDate = new Date();
    baseDate.setDate(baseDate.getDate() - 1); // subtract 1 day
    this.schedService.getHearingDates().subscribe(data => {
      if (data) {
        this.schedDateList = data.filter(t => {
          const tHearDt = new Date(t.hearingDate);
          // return t;   // return ALL dates, not just future ones... used during testing/cleanup
          return tHearDt >= baseDate ? t : null;
        });
        // sort it in chronological order
        this.schedDateList.sort((a, b) => {
          // @ts-ignore
          return new Date(a.hearingDate) - new Date(b.hearingDate);
        });
        const mapped = this.schedDateList.map(item => ({
          ...item,
          // create new field based on the hearingDate (w/o time part) + hearingTime
          hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
        }));
        this.utilService.doAudit(mapped, 'mapped hearing list:');
        this.schedDateList = mapped;
      }
    });
  }

  // Toaster-related methods
  showToast(msg: Message) {
    this.messageService.add(msg);
  }

  clear() {
    this.messageService.clear();
  }
}
